<template>
  <div class="alert-verify-modal-root">
    <transition name="modal-fade">
      <div
        v-if="addNewDataLocal"
        class="modern-modal__overlay"
        @click.self="closeForm">
        <div class="modern-modal modern-modal--lg">
          <header class="modern-modal__header">
            <div>
              <h3 class="modern-modal__title">{{ title }}</h3>
            </div>
            <button class="modern-modal__close" type="button" @click="closeForm">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>

          <section class="modern-modal__body">
            <div class="modern-modal__scroll">
              <vs-tabs :value="tabIndex">
                <vs-tab label="Verification" @click="tabIndex = 0">
                  <p class="modern-modal__intro">
                    Memberikan teguran kepada driver dengan batas waktu maksimal
                    selama {{ eventType == "MB_CN" ? '14 hari' : '4 jam' }}.
                  </p>
                  <form class="mt-5">
                    <div
                      class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label for="" class="text-bold">Problem Category</label>
                      <vs-select
                        class="w-full"
                        label=""
                        v-model="problem_category"
                        :disabled="!this.is_editable">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item, index) in listProblemCategoriesVerification" />
                      </vs-select>
                    </div>

                    <div
                      class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label for="">Problem Identification</label>
                      <vs-select
                        class="w-full"
                        label=""
                        v-model="problem_identification"
                        :disabled="!this.is_editable">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item, index) in listProblemIdentifications" />
                      </vs-select>
                    </div>
                    <div
                      class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Notes<sup>*</sup></label>
                      <div>
                        <vs-textarea
                          v-model="notes"
                          rows="5"
                          style="border: 1px solid rgba(0, 0, 0, 0.2)"
                          :disabled="!this.is_editable" />
                      </div>
                      <span></span>
                    </div>

                    <div
                      class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <br />
                      <div v-if="dataEdit.attachment">
                        <template
                          v-if="
                            Array.isArray(dataEdit.attachment) &&
                            dataEdit.attachment.length
                          ">
                          <img
                            v-for="(attachment, index) in dataEdit.attachment"
                            :key="index"
                            class="cursor-pointer mr-2"
                            height="150px"
                            :src="attachment"
                            @click="onClickImage(attachment)"
                            alt="Uploaded Image" />
                        </template>
                        <template v-else>
                          <img
                            v-if="dataEdit.attachment"
                            class="cursor-pointer mr-2"
                            height="150px"
                            :src="dataEdit.attachment"
                            @click="onClickImage(dataEdit.attachment)"
                            alt="Uploaded Image" />
                        </template>
                      </div>
                      <div
                        :class="!this.is_editable ? 'hidden' : 'flex flex-col-reverse'"
                        style="gap: 10px; flex-wrap: wrap">
                        <div class="fileUpload rounded-lg flex" v-if="images.length < 3">
                          <input
                            type="file"
                            class="upload"
                            @change="handlePictureChange"
                            :key="fileUploadKey"
                            multiple
                            accept="image/*" />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none">
                            <path
                              d="M4.5551 16.5556C2.60745 16.5556 1.02856 15.2273 1.02856 13.2796C1.02856 11.332 2.60745 9.75307 4.5551 9.75307C4.68754 9.75307 4.81828 9.76038 4.94693 9.7746V9.75307H4.99544C4.96342 9.49635 4.94693 9.2348 4.94693 8.9694C4.94693 5.50691 7.75383 2.70001 11.2163 2.70001C13.561 2.70001 15.6051 3.98715 16.6805 5.89339C16.9433 5.85473 17.2122 5.83471 17.4857 5.83471C20.5154 5.83471 22.9714 8.29074 22.9714 11.3204C22.9714 13.8144 21.3071 15.7156 19.0286 16.3423M11.8269 21.3V12.3M11.8269 12.3L8.22856 16.0117M11.8269 12.3L15.4286 16.0117"
                              stroke="#828282"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                          <span class="ml-2">Upload Picture</span>
                        </div>
                        <div class="flex flex-row" style="gap: 15px">
                          <div
                            v-for="(image, index) in images"
                            :key="index"
                            class="mr-2 flex flex-col"
                            style="width: fit-content">
                            <img
                              :src="imageUrl(image)"
                              height="150px"
                              alt="Uploaded Image"
                              class="cursor-pointer"
                              @click="onClickImage(imageUrl(image))" />
                            <vs-button
                              color="danger"
                              type="border"
                              size="small"
                              @click="removeImage(index)">
                              Remove
                            </vs-button>
                          </div>
                        </div>
                      </div>
                      <p class="text-xs mt-3 ml-2">
                        *Only accepts image files (.jpg, .jpeg, .png)
                      </p>
                      <span></span>
                    </div>
                  </form>
                </vs-tab>
                <vs-tab
                  label="Validation"
                  @click="tabIndex = 1"
                  :disabled="tabValidation">
                  <p class="modern-modal__intro">
                    Upload bukti Surat Peringatan (SP) kepada driver dengan batas
                    waktu maksimal selama {{ eventType == "MB_CN" ? '14 hari' : '4 hari' }}.
                  </p>
                  <form class="mt-5">
                    <div
                      class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label for="" class="text-bold">Problem Category</label>
                      <vs-select
                        class="w-full"
                        label=""
                        v-model="problem_category"
                        :disabled="!problemEdit">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item, index) in listProblemCategoriesValidation" />
                      </vs-select>
                    </div>

                    <div
                      class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label for="">Problem Identification</label>
                      <vs-select
                        class="w-full"
                        label=""
                        v-model="problem_identification"
                        :disabled="!problemEdit">
                        <vs-select-item
                          :key="index"
                          :value="item.value"
                          :text="item.text"
                          v-for="(item, index) in listProblemIdentifications" />
                      </vs-select>
                    </div>
                    <div
                      class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
                      <label class="vs-input--label">Notes<sup>*</sup></label>
                      <div>
                        <vs-textarea
                          v-model="notesValidation"
                          rows="5"
                          style="border: 1px solid rgba(0, 0, 0, 0.2)"
                          :disabled="!this.is_editable_validation" />
                      </div>
                      <span></span>
                    </div>

                    <div
                      class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
                      style="gap: 20px">
                      <br />
                      <span class="ml-2 font-bold">Bukti Coahing</span>
                      <div v-if="dataEdit.attachment_validation">
                        <template
                          v-if="
                            Array.isArray(dataEdit.attachment_validation) &&
                            dataEdit.attachment_validation.length
                          ">
                          <img
                            v-for="(attachment, index) in dataEdit.attachment_validation"
                            :key="index"
                            class="cursor-pointer mr-2"
                            height="150px"
                            :src="attachment"
                            @click="onClickImage(attachment)"
                            alt="Uploaded Image" />
                        </template>
                        <template v-else>
                          <img
                            v-if="dataEdit.attachment_validation"
                            class="cursor-pointer mr-2"
                            height="150px"
                            :src="dataEdit.attachment_validation"
                            @click="onClickImage(dataEdit.attachment_validation)"
                            alt="Uploaded Image" />
                        </template>
                      </div>
                      <div
                        :class="!this.is_editable_validation ? 'hidden' : 'flex flex-col'"
                        style="gap: 10px; flex-wrap: wrap">
                        <div
                          class="fileUpload rounded-lg flex"
                          v-if="imagesValidation.length < 3">
                          <input
                            type="file"
                            class="upload"
                            @change="handlePictureChangeValidation"
                            :key="fileUploadKey"
                            multiple
                            accept="image/*" />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none">
                            <path
                              d="M4.5551 16.5556C2.60745 16.5556 1.02856 15.2273 1.02856 13.2796C1.02856 11.332 2.60745 9.75307 4.5551 9.75307C4.68754 9.75307 4.81828 9.76038 4.94693 9.7746V9.75307H4.99544C4.96342 9.49635 4.94693 9.2348 4.94693 8.9694C4.94693 5.50691 7.75383 2.70001 11.2163 2.70001C13.561 2.70001 15.6051 3.98715 16.6805 5.89339C16.9433 5.85473 17.2122 5.83471 17.4857 5.83471C20.5154 5.83471 22.9714 8.29074 22.9714 11.3204C22.9714 13.8144 21.3071 15.7156 19.0286 16.3423M11.8269 21.3V12.3M11.8269 12.3L8.22856 16.0117M11.8269 12.3L15.4286 16.0117"
                              stroke="#828282"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                        </div>
                        <div class="flex flex-row" style="gap: 15px">
                          <div
                            v-for="(image, index) in imagesValidation"
                            :key="index"
                            class="mr-2 flex flex-col"
                            style="width: fit-content">
                            <img
                              :src="imageUrl(image)"
                              height="150px"
                              alt="Uploaded Image"
                              class="cursor-pointer"
                              @click="onClickImage(imageUrl(image))" />
                            <vs-button
                              color="danger"
                              type="border"
                              size="small"
                              @click="removeImageValidation(index)">
                              Remove
                            </vs-button>
                          </div>
                        </div>
                        <p class="text-xs mt-3 ml-2">
                          *Only accepts image files (.jpg, .jpeg, .png)
                        </p>
                      </div>
                      <span></span>
                      <span class="ml-2 font-bold">Bukti Punishment</span>
                      <div v-if="dataEdit.attachment_validation2">
                        <template
                          v-if="
                            Array.isArray(dataEdit.attachment_validation2) &&
                            dataEdit.attachment_validation2.length
                          ">
                          <img
                            v-for="(attachment, index) in dataEdit.attachment_validation2"
                            :key="index"
                            class="cursor-pointer mr-2"
                            height="150px"
                            :src="attachment"
                            @click="onClickImage(attachment)"
                            alt="Uploaded Image" />
                        </template>
                        <template v-else>
                          <img
                            v-if="dataEdit.attachment_validation2"
                            class="cursor-pointer mr-2"
                            height="150px"
                            :src="dataEdit.attachment_validation2"
                            @click="onClickImage(dataEdit.attachment_validation2)"
                            alt="Uploaded Image" />
                        </template>
                      </div>
                      <div
                        :class="!this.is_editable_validation ? 'hidden' : 'flex flex-col'"
                        style="gap: 10px; flex-wrap: wrap">
                        <div
                          class="fileUpload rounded-lg flex"
                          v-if="imagesValidation2.length < 3">
                          <input
                            type="file"
                            class="upload"
                            @change="handlePictureChangeValidation2"
                            :key="fileUploadKey2"
                            multiple
                            accept="image/*" />
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none">
                            <path
                              d="M4.5551 16.5556C2.60745 16.5556 1.02856 15.2273 1.02856 13.2796C1.02856 11.332 2.60745 9.75307 4.5551 9.75307C4.68754 9.75307 4.81828 9.76038 4.94693 9.7746V9.75307H4.99544C4.96342 9.49635 4.94693 9.2348 4.94693 8.9694C4.94693 5.50691 7.75383 2.70001 11.2163 2.70001C13.561 2.70001 15.6051 3.98715 16.6805 5.89339C16.9433 5.85473 17.2122 5.83471 17.4857 5.83471C20.5154 5.83471 22.9714 8.29074 22.9714 11.3204C22.9714 13.8144 21.3071 15.7156 19.0286 16.3423M11.8269 21.3V12.3M11.8269 12.3L8.22856 16.0117M11.8269 12.3L15.4286 16.0117"
                              stroke="#828282"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                          <span class="ml-2">Upload Picture</span>
                        </div>
                        <div class="flex flex-row" style="gap: 15px">
                          <div
                            v-for="(image, index) in imagesValidation2"
                            :key="index"
                            class="mr-2 flex flex-col"
                            style="width: fit-content">
                            <img
                              :src="imageUrl(image)"
                              height="150px"
                              alt="Uploaded Image"
                              class="cursor-pointer"
                              @click="onClickImage(imageUrl(image))" />
                            <vs-button
                              color="danger"
                              type="border"
                              size="small"
                              @click="removeImageValidation2(index)">
                              Remove
                            </vs-button>
                          </div>
                        </div>
                        <p class="text-xs mt-3 ml-2">
                          *Only accepts image files (.jpg, .jpeg, .png)
                        </p>
                      </div>
                      <span></span>
                    </div>
                  </form>
                </vs-tab>
              </vs-tabs>
            </div>
          </section>

          <footer class="modern-modal__footer">
            <vs-button color="warning" type="border" class="mb-0" @click="closeForm">
              Cancel
            </vs-button>
            <vs-button
              v-if="tabIndex === 0 && this.is_editable"
              color="danger"
              type="filled"
              class="mb-0 btn-submit"
              @click="submitsForm"
              :disabled="
                this.problem_identification === '' ||
                this.problem_category === '' ||
                notes === '' ||
                images.length === 0
              ">
              Submit
            </vs-button>
            <vs-button
              v-if="tabIndex === 1 && this.is_editable_validation && this.problemEdit"
              color="danger"
              type="filled"
              class="mb-0 btn-submit"
              @click="submitsFormValidation"
              :disabled="
                this.problem_identification === '' ||
                this.problem_category === '' ||
                notesValidation === '' ||
                imagesValidation.length === 0 ||
                imagesValidation2.length === 0
              ">
              Submit
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as REPO from '../../../repository/index'
import * as moment from 'moment'
import imageCompression from 'browser-image-compression'
import {
  getVerificationProblemCategories,
  getValidationProblemCategories,
  getProblemIdentificationsFromJson,
} from '../../../helper/problemOptions'

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    id: String,
    imei: String,
    title: String,
    editMode: Boolean,
    dataEdit: Object,
    typeAsign: String,
    eventType: String,
  },
  mounted() {
    //
  },
  watch: {
    async dataEdit(val) {
      this.tabIndex = 0
      this.clearFields()
      if (this.editMode) {
        this.notes = this.dataEdit.note
        this.deviceTime = this.dataEdit.device_time
        this.notesValidation = this.dataEdit.note_validation
        if (this.dataEdit.problem_category) {
          this.problem_category = this.dataEdit.problem_category
          this.problem_identification = this.dataEdit.problem_identification
          this.problemEdit = this.dataEdit.problem_category != ''
        }
        if (Array.isArray(this.dataEdit.attachment)) {
          this.dataEdit.attachment.map(async (attachment) => {
            try {
              const res = await fetch(attachment)
              const blob = await res.blob()
              const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
              this.images.push(file)
            } catch (error) {
              console.error('Error fetching or processing attachment:', error)
            }
          })
        } else if (this.dataEdit.attachment) {
          try {
            const res = await fetch(this.dataEdit.attachment)
            const blob = await res.blob()
            const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
            this.images.push(file)
          } catch (error) {
            console.error('Error fetching or processing attachment:', error)
          }
        }
        if (Array.isArray(this.dataEdit.attachment_validation)) {
          this.dataEdit.attachment_validation.map(
            async (attachment_validation) => {
              try {
                const res = await fetch(attachment_validation)
                const blob = await res.blob()
                const file = new File([blob], 'image.jpg', {
                  type: 'image/jpeg',
                })
                this.imagesValidation.push(file)
              } catch (error) {
                console.error(
                  'Error fetching or processing attachment_validation:',
                  error
                )
              }
            }
          )
        } else if (this.dataEdit.attachment_validation) {
          try {
            const res = await fetch(this.dataEdit.attachment_validation)
            const blob = await res.blob()
            const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
            this.imagesValidation.push(file)
          } catch (error) {
            console.error(
              'Error fetching or processing attachment_validation:',
              error
            )
          }
        }
        if (Array.isArray(this.dataEdit.attachment_validation2)) {
          this.dataEdit.attachment_validation2.map(
            async (attachment_validation2) => {
              try {
                const res = await fetch(attachment_validation2)
                const blob = await res.blob()
                const file = new File([blob], 'image.jpg', {
                  type: 'image/jpeg',
                })
                this.imagesValidation2.push(file)
              } catch (error) {
                console.error(
                  'Error fetching or processing attachment_validation2:',
                  error
                )
              }
            }
          )
        } else if (this.dataEdit.attachment_validation2) {
          try {
            const res = await fetch(this.dataEdit.attachment_validation2)
            const blob = await res.blob()
            const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
            this.imagesValidation2.push(file)
          } catch (error) {
            console.error(
              'Error fetching or processing attachment_validation2:',
              error
            )
          }
        }
        if (this.notes != '') {
          this.is_editable = false
        }

        if (moment(this.deviceTime).isBefore(moment().subtract(4, 'hours'))) {
          this.is_editable = false
        }

        if (this.notesValidation != '') {
          this.is_editable_validation = false
        }

        if (moment(this.deviceTime).isBefore(moment().subtract(4, 'days'))) {
          this.is_editable_validation = false
        }
      }
    },
    // async editMode(val) {
    //   this.clearFields()
    //   if (
    //     this.dataEdit.verified_by.name != null &&
    //     this.dataEdit.verified_by.name != ''
    //   ) {
    //     this.notes = this.dataEdit.note
    //     this.deviceTime = this.dataEdit.device_time
    //     this.notesValidation = this.dataEdit.note_validation
    //     if (Array.isArray(this.dataEdit.attachment)) {
    //       this.dataEdit.attachment.map(async (attachment) => {
    //         try {
    //           const res = await fetch(attachment)
    //           const blob = await res.blob()
    //           const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
    //           this.images.push(file)
    //         } catch (error) {
    //           console.error('Error fetching or processing attachment:', error)
    //         }
    //       })
    //     } else if (this.dataEdit.attachment) {
    //       try {
    //         const res = await fetch(this.dataEdit.attachment)
    //         const blob = await res.blob()
    //         const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
    //         this.images.push(file)
    //       } catch (error) {
    //         console.error('Error fetching or processing attachment:', error)
    //       }
    //     }
    //     if (Array.isArray(this.dataEdit.attachment_validation)) {
    //       this.dataEdit.attachment_validation.map(async (attachment_validation) => {
    //         try {
    //           const res = await fetch(attachment_validation)
    //           const blob = await res.blob()
    //           const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
    //           this.imagesValidation.push(file)
    //         } catch (error) {
    //           console.error('Error fetching or processing attachment:', error)
    //         }
    //       })
    //     } else if (this.dataEdit.attachment_validation) {
    //       try {
    //         const res = await fetch(this.dataEdit.attachment_validation)
    //         const blob = await res.blob()
    //         const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
    //         this.imagesValidation.push(file)
    //       } catch (error) {
    //         console.error('Error fetching or processing attachment:', error)
    //       }
    //     }

    //     if ((this.notes != '' && this.notes != undefined) || moment(this.deviceTime).isBefore(moment().subtract(4, 'hours'))) {
    //       this.is_editable = false
    //     }

    //     if (this.notesValidation != '' && this.notesValidation != undefined) {
    //       this.is_editable_validation = false
    //     }
    //   }
    // },
    // images(val) {
    //
    // },
    problem_category(val) {
      const problemIdentifications = getProblemIdentificationsFromJson(val)
      if (problemIdentifications) {
        this.listProblemIdentifications = problemIdentifications
        return
      }

      switch (val) {
        case 'Pengemudi':
          this.listProblemIdentifications = [
            { value: 'Melanggar Kebijakan', text: 'Melanggar Kebijakan' },
            {
              value: 'Overstay Engine On Di Dc',
              text: 'Overstay Engine On Di Dc',
            },
            {
              value: 'Overstay Engine On Di Jalan',
              text: 'Overstay Engine On Di Jalan',
            },
            {
              value: 'Overstay Engine On Di Toko',
              text: 'Overstay Engine On Di Toko',
            },
            {
              value:
                'Overstay Engine On Mesin Mati Namun Kunci Kontak On Di Dc',
              text: 'Overstay Engine On Mesin Mati Namun Kunci Kontak On Di Dc',
            },
            {
              value:
                'Overstay Engine On Mesin Mati Namun Kunci Kontak On Di Jalan',
              text: 'Overstay Engine On Mesin Mati Namun Kunci Kontak On Di Jalan',
            },
            {
              value:
                'Overstay Engine On Mesin Mati Namun Kunci Kontak On Di Toko',
              text: 'Overstay Engine On Mesin Mati Namun Kunci Kontak On Di Toko',
            },
            {
              value: 'Overstay Engine On Mesin Pada Saat Antri Di Pom Bensin',
              text: 'Overstay Engine On Mesin Pada Saat Antri Di Pom Bensin',
            },
            {
              value: 'Driver Sengaja Menyalakan Unit',
              text: 'Driver Sengaja Menyalakan Unit',
            },
            {
              value: 'Pencurian Yang Melibatkan Driver',
              text: 'Pencurian Yang Melibatkan Driver',
            },
          ]
          break
        case 'Operasional':
          this.listProblemIdentifications = [
            {
              value: 'Pengemudi Melanggar Kecepatan Karena Permintaan Customer',
              text: 'Pengemudi Melanggar Kecepatan Karena Permintaan Customer',
            },
            {
              value: 'Terjebak Macet',
              text: 'Terjebak Macet',
            },
            { value: 'Unit Belum Di Mutasi', text: 'Unit Belum Di Mutasi' },
            {
              value: 'Unit Overstay Engine On Disebabkan Oleh Checker / Jukir',
              text: 'Unit Overstay Engine On Disebabkan Oleh Checker / Jukir',
            },
          ]
          break
        case 'Fico Verifikasi':
          this.listProblemIdentifications = [
            {
              value: 'Pengemudi Belum Di Briefing Terkait Kebijakan Overspeed',
              text: 'Pengemudi Belum Di Briefing Terkait Kebijakan Overspeed',
            },
            {
              value:
                'Pengemudi Freelance Belum Di Briefing Terkait Kebijakan Overspeed',
              text: 'Pengemudi Freelance Belum Di Briefing Terkait Kebijakan Overspeed',
            },
          ]
          break
        case 'Fico Tidak Verifikasi':
          this.listProblemIdentifications = [
            { value: 'Fico Tidak Verifikasi', text: 'Fico Tidak Verifikasi' },
          ]
          break
        case 'Sistem':
          this.listProblemIdentifications = [
            { value: 'Sistem Error', text: 'Sistem Error' },
            { value: 'Akun Belum Di Buat', text: 'Akun Belum Di Buat' },
            {
              value: 'Terdeteksi Overstay Engine On Pada Saat Macet',
              text: 'Terdeteksi Overstay Engine On Pada Saat Macet',
            },
            {
              value: 'Terdeteksi Overstay Engine On Di Dc',
              text: 'Terdeteksi Overstay Engine On Di Dc',
            },
            {
              value: 'Terdeteksi Overstay Engine On Di Toko',
              text: 'Terdeteksi Overstay Engine On Di Toko',
            },
            {
              value:
                'Terdeteksi Overstay Engine On Karena Error Tidak Sesuai Ketentuan',
              text: 'Terdeteksi Overstay Engine On Karena Error Tidak Sesuai Ketentuan',
            },
          ]
          break
        case 'Kendaraan':
          this.listProblemIdentifications = [
            {
              value: 'Aki Error Sehingga Unit Overstay Engine On',
              text: 'Aki Error Sehingga Unit Overstay Engine On',
            },
            {
              value: 'Overstay Engine On Karena Unit Ada Di Bengkel',
              text: 'Overstay Engine On Karena Unit Ada Di Bengkel',
            },
            { value: 'Unit Belum Dimutasi', text: 'Unit Belum Dimutasi' },
            { value: 'Speedometer Error', text: 'Speedometer Error' },
            {
              value: 'Unit Dibawa Mekanik/Driver Ekspedisi',
              text: 'Unit Dibawa Mekanik/Driver Ekspedisi',
            },
          ]
          break
        case 'Others':
          this.listProblemIdentifications = [
            { value: 'Unit Di Curi', text: 'Unit Di Curi' },
          ]
          break
        default:
          this.listProblemIdentifications = []
          break
      }
    },
  },
  computed: {
    addNewDataLocal: {
      get() {
        const raw = this.isOpen
        let isOpen = false

        if (typeof raw === 'string') {
          const normalized = raw.trim().toLowerCase()
          if (normalized === 'true' || normalized === 'false') {
            isOpen = normalized === 'true'
          } else {
            try {
              isOpen = JSON.parse(raw)
            } catch (err) {
              isOpen = raw.length > 0
            }
          }
        } else {
          isOpen = !!raw
        }

        if (isOpen && this.dataEdit && this.dataEdit.device_time) {
          const deviceTime = moment(this.dataEdit.device_time)
          if (deviceTime.isBefore(moment().subtract(4, 'hours'))) {
            this.is_editable = false
          }

          if (deviceTime.isBefore(moment().subtract(4, 'days'))) {
            this.is_editable_validation = false
          }
        }

        return isOpen
      },
      set(val) {
        if (!val) {
          this.closeForm()
        }
      },
    },

    validateForm() {
      return !this.errors.any() && this.mailTo !== ''
    },
  },
  data() {
    return {
      tabIndex: 0,
      tabValidation: false,
      parent_array: [],
      is_editable: true,
      is_editable_validation: true,
      problemEdit: true,
      notes: '',
      images: [],
      notesValidation: '',
      imagesValidation: [],
      imagesValidation2: [],
      fileUploadKey: 0,
      fileUploadKey2: 0,
      legacyProblemCategories: [
        { value: 'Pengemudi', text: 'Pengemudi' },
        { value: 'Operasional', text: 'Operasional' },
        { value: 'Fico Verifikasi', text: 'Fico Verifikasi' },
        { value: 'Fico Tidak Verifikasi', text: 'Fico Tidak Verifikasi' },
        { value: 'Sistem', text: 'Sistem' },
        { value: 'Kendaraan', text: 'Kendaraan' },
        { value: 'Others', text: 'Others' },
      ],
      listProblemCategoriesVerification: getVerificationProblemCategories(),
      listProblemCategoriesValidation: getValidationProblemCategories(),
      listProblemIdentifications: [],
      problem_category: '',
      problem_identification: '',
    }
  },
  methods: {
    imageUrl(image) {
      return URL.createObjectURL(image)
    },
    onClickImage(attachment) {
      window.open(attachment, '_blank')
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.problem_category = ''
      this.problem_identification = ''
      this.notes = ''
      this.note_validation = ''
      this.images = []
      this.imagesValidation = []
      this.imagesValidation2 = []
      this.fileUploadKey++
      this.fileUploadKey2++
      this.is_editable = true
      this.is_editable_validation = true
      this.problemEdit = true
    },
    handlePictureChange(e) {
      const selectedFiles = Array.from(e.target.files)
      if (this.images.length + selectedFiles.length <= 3) {
        this.images.push(...selectedFiles)
      } else {
        alert('You can only upload a maximum of 3 images.')
      }
    },
    handlePictureChangeValidation(e) {
      const selectedFiles = Array.from(e.target.files)
      if (this.imagesValidation.length + selectedFiles.length <= 3) {
        this.imagesValidation.push(...selectedFiles)
      } else {
        alert('You can only upload a maximum of 3 images.')
      }
    },
    handlePictureChangeValidation2(e) {
      const selectedFiles = Array.from(e.target.files)
      if (this.imagesValidation2.length + selectedFiles.length <= 3) {
        this.imagesValidation2.push(...selectedFiles)
      } else {
        alert('You can only upload a maximum of 3 images.')
      }
    },
    removeImage(index) {
      this.images.splice(index, 1)
    },
    removeImageValidation(index) {
      this.imagesValidation.splice(index, 1)
    },
    removeImageValidation2(index) {
      this.imagesValidation2.splice(index, 1)
    },
    successUpload() {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Files uploaded successfully',
      })
    },
    async submitsForm() {
      this.loadingBtnStart('btn-submit')
      let dataForm = {
        imei: this.imei,
        note: this.notes,
        verified_date: moment().format('YYYY-MM-DD HH:mm'),
        verified_by: JSON.parse(localStorage.getItem('userInfo')).name,
        problem_category: this.problem_category,
        problem_identification: this.problem_identification,
      }

      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        }
        const uploadPromises = this.images.map(async (image, index) => {
          const compressedFile = await imageCompression(image, options)
          const formData = new FormData()
          formData.append('file', compressedFile)
          formData.append('dir', 'alert' + '/' + this.dataEdit.license_plate)

          const response = await REPO.updateFileHistory(
            formData,
            this.id + Date.now() + 'attach_' + index
          )
          return response.data.data.url
        })

        const uploadedUrls = await Promise.all(uploadPromises)
        dataForm.attachment = uploadedUrls

        await REPO.updateAlertHistory(dataForm, this.id)
        this.loadingBtnStop('btn-submit')
        this.$emit('submitModal', false)
        this.successUpload()
        this.closeForm()
        this.$root.$emit('reloadNotifAtas')
      } catch (error) {
        console.error(error)
      }
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    async submitsFormValidation() {
      this.loadingBtnStart('btn-submit')
      let dataForm = {
        imei: this.imei,
        note_validation: this.notesValidation,
        validation_date: moment().format('YYYY-MM-DD HH:mm'),
        validation_by: JSON.parse(localStorage.getItem('userInfo')).name,
      }

      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        }
        const uploadPromises = this.imagesValidation.map(
          async (image, index) => {
            const compressedFile = await imageCompression(image, options)
            const formData = new FormData()
            formData.append('file', compressedFile)
            formData.append('dir', 'alert' + '/' + this.dataEdit.license_plate)

            const response = await REPO.updateFileHistory(
              formData,
              this.id + Date.now() + 'attachvalidation_' + index
            )
            return response.data.data.url
          }
        )
        const uploadPromises2 = this.imagesValidation2.map(
          async (image, index) => {
            const compressedFile = await imageCompression(image, options)
            const formData = new FormData()
            formData.append('file', compressedFile)
            formData.append('dir', 'alert' + '/' + this.dataEdit.license_plate)

            const response = await REPO.updateFileHistory(
              formData,
              this.id + Date.now() + 'attachvalidation_' + index
            )
            return response.data.data.url
          }
        )

        const uploadedUrls = await Promise.all(uploadPromises)
        const uploadedUrls2 = await Promise.all(uploadPromises2)
        dataForm.attachment_validation = uploadedUrls
        dataForm.attachment_validation2 = uploadedUrls2

        await REPO.updateAlertHistory(dataForm, this.id)
        this.loadingBtnStop('btn-submit')
        this.$emit('submitModal', false)
        this.successUpload()
        this.closeForm()
        this.$root.$emit('reloadNotifAtas')
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>
<style>
#content-area.content-area-default .alert-verify-modal-root .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced .alert-verify-modal-root .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .alert-verify-modal-root .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced)
  .alert-verify-modal-root .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .alert-verify-modal-root .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }
}
</style>

<style scoped>
.alert-verify-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(760px, 96vw);
  max-height: 82vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 28px 16px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 22px 28px 0;
  overflow: hidden;
}

.modern-modal__scroll {
  max-height: calc(82vh - 175px);
  overflow-y: auto;
  padding-right: 6px;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 28px 24px;
  border-top: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.modern-modal__intro {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #475569;
}

.modern-modal__body ::v-deep(.vs-tabs .con-ul-tabs) {
  margin-bottom: 18px;
}

.modern-modal__body ::v-deep(.vs-tabs .con-ul-tabs li) {
  margin-right: 6px;
}

.modern-modal__body ::v-deep(.vs-tabs .con-ul-tabs li button) {
  border-radius: 9999px;
  padding: 6px 18px;
  font-weight: 600;
}

.modern-modal__body ::v-deep(.vs-tabs .con-tab) {
  padding: 0;
}

.modern-modal__body ::v-deep(.vs-con-input-label) {
  background: rgba(241, 245, 249, 0.65);
  border-radius: 14px;
  padding: 18px 18px 12px;
  border: 1px solid rgba(203, 213, 225, 0.6);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.modern-modal__body ::v-deep(.vs-con-input-label:hover) {
  border-color: rgba(148, 163, 184, 0.8);
}

.modern-modal__body ::v-deep(.vs-con-input-label:focus-within) {
  border-color: #2563eb;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.modern-modal__body ::v-deep(.vs-input--label) {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 8px;
}

.modern-modal__body ::v-deep(.vs-con-input) {
  border-radius: 12px;
  border: 1px solid #d0d5dd;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.modern-modal__body ::v-deep(.vs-con-input:focus-within) {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.modern-modal__body ::v-deep(.vs-inputx.vs-input--input.normal) {
  border: none;
  background: transparent;
  padding: 12px 16px;
  font-size: 0.94rem;
  line-height: 1.5;
  color: #0f172a;
}

.modern-modal__body ::v-deep(.vs-textarea textarea) {
  border-radius: 12px;
}

.fileUpload {
  background: transparent;
  color: #333333;
  font-size: 1em;
  overflow: hidden;
  padding: 0.875em;
  position: relative;
  text-align: center;
  width: fit-content;
  cursor: pointer;
  border: 1px solid var(--Gray-4, #bdbdbd);
}

.fileUpload:hover,
.fileUpload:active,
.fileUpload:focus {
  background: transparent;
  cursor: pointer;
}

.fileUpload input.upload {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  font-size: 20px;
  cursor: pointer;
  opacity: 0;
  width: 148px;
  height: 46px;
}

input[type='file'] {
  position: fixed;
  right: 100%;
  bottom: 100%;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

textarea:disabled {
  background-color: #f0f0f0;
  color: #888888;
  opacity: 0.6;
  cursor: not-allowed;
}

sup {
  color: red;
}
</style>
